import { useRef, useState, type ReactNode } from 'react';
import inlineStyles from './DocInlineDate.module.css';
import { CalendarPopover } from './DocCalendar';

export interface DocInlineDateProps {
  /** Aktuální hodnota (české formáty „19. 04. 2026" i ISO „2026-04-19" jsou OK). */
  value: string;
  onChange: (value: string) => void;
  /** Tooltip / aria-label pro tlačítko. */
  title?: string;
  /** Ikonka — výchozí 📅. */
  buttonLabel?: ReactNode;
}

/**
 * Malé tlačítko 📅 vedle inline data v dokumentu — otevře popup kalendář.
 * Používá se v `actions=` slotu DocRow; samotná hodnota data se píše do row inputu.
 * Kalendář se renderuje přes portal (viz CalendarPopover), takže ho neořezává
 * scrollovací kontejner dokumentu.
 */
export function DocInlineDate({
  value,
  onChange,
  title = 'Otevřít kalendář',
  buttonLabel = '📅',
}: DocInlineDateProps) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement | null>(null);

  return (
    <span className={inlineStyles.wrap}>
      <button
        ref={btnRef}
        type="button"
        className={inlineStyles.btn}
        onClick={() => setOpen((s) => !s)}
        title={title}
        aria-label={title}
      >
        {buttonLabel}
      </button>

      {open && (
        <CalendarPopover
          anchorEl={btnRef.current}
          value={value}
          onChange={onChange}
          onClose={() => setOpen(false)}
        />
      )}
    </span>
  );
}
